export interface SalesPacksForDespatchNote {
  id: string;
  packNo: number;
  orderNo: string;
  customerKey: string;
  customerName: string;
  customerPackNo: string;
  productKey: string;
  productDescription: string;
  grossQuantity: number;
  nettQuantity: number;
  height: number;
  width: number;
  depth: number;
  packTypeKey: string;
  packTypeDescription: string;
  datePacked: Date;
  packedBy: string;
  shippingPackId: string;
  shippingPackKey: string;
  shippingPackDescription: string;
  selected: boolean;
}
